import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dialog", "image", "caption", "counter", "previous", "next", "original", "close", "stage", "status"]

  connect() {
    this.keydown = event => {
      if (!this.dialogTarget.open) return
      if (event.key === "ArrowLeft" || event.key === "ArrowRight") {
        event.preventDefault()
        event.key === "ArrowLeft" ? this.previous() : this.next()
      }
    }
    this.beforeCache = () => this.close()
    document.addEventListener("keydown", this.keydown)
    document.addEventListener("turbo:before-cache", this.beforeCache)
  }

  open(event) {
    if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return
    event.preventDefault()
    this.trigger = event.currentTarget
    const group = this.trigger.dataset.photoViewerGroup
    this.items = Array.from(document.querySelectorAll("a[data-photo-viewer-group]")).filter(link => link.dataset.photoViewerGroup === group)
    this.index = this.items.indexOf(this.trigger)
    this.overflow = document.body.style.overflow
    document.body.style.overflow = "hidden"
    this.show()
    this.dialogTarget.showModal()
    this.closeTarget.focus({ preventScroll: true })
  }

  show() {
    const link = this.items[this.index]
    this.statusTarget.textContent = "Загрузка…"
    this.imageTarget.src = link.href
    this.imageTarget.alt = link.dataset.photoViewerAlt || link.querySelector("img")?.alt || "Фотография"
    this.originalTarget.href = link.href
    this.captionTarget.textContent = link.dataset.photoViewerCaption || ""
    this.counterTarget.textContent = `${this.index + 1} / ${this.items.length}`
    this.previousTarget.hidden = this.nextTarget.hidden = this.items.length < 2
  }

  next() {
    this.index = (this.index + 1) % this.items.length
    this.show()
  }

  previous() {
    this.index = (this.index - 1 + this.items.length) % this.items.length
    this.show()
  }

  loaded() { this.statusTarget.textContent = "" }
  failed() { this.statusTarget.textContent = "Не удалось загрузить фото. Попробуйте открыть оригинал." }

  backdrop(event) {
    if (event.target === this.dialogTarget || event.target === this.stageTarget) this.close()
  }

  cancel(event) {
    event.preventDefault()
    this.close()
  }

  close() {
    if (!this.dialogTarget.open) return
    this.dialogTarget.close()
    document.body.style.overflow = this.overflow
    this.imageTarget.removeAttribute("src")
    if (this.trigger?.isConnected) this.trigger.focus({ preventScroll: true })
  }

  disconnect() {
    this.close()
    document.removeEventListener("keydown", this.keydown)
    document.removeEventListener("turbo:before-cache", this.beforeCache)
  }
}
